module.exports = __webpack_public_path__ + "img/Bitmap@2x (2).cd508be1.png";